export default {
  CHANGE: "CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  GET_MENU: "GET_MENU",
  TOGGLE_MENU: "TOGGLE_MENU"
};
